$(document).ready(function(){
$('.main-features-images ul').slick({
 	slidesToShow: 1,
 	slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0603/7645/files/image_4.svg?v=1679921218"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0603/7645/files/image_4_-svg.svg?v=1679921218"></button>',
 	fade: false,
 	// adaptiveHeight: true,
 	infinite: false,
	
 });

 $('.thumbnail-slider ul').on('init', function(event, slick) {
 		$('.thumbnail-slider ul .slick-slide.slick-current').addClass('is-active');
 	}).slick({
 		slidesToShow: 4,
 		slidesToScroll: 1,
 		dots: false,
        infinite: false,
 		responsive: [
         {
 			breakpoint: 575,
 			settings: {
 				slidesToShow: 4,
 				slidesToScroll: 1,
		   }
 		}
      ]
 	});

 $('.main-features-images ul').on('afterChange', function(event, slick, currentSlide) {
 	$('.thumbnail-slider ul').slick('slickGoTo', currentSlide);
 	var currrentNavSlideElem = '.thumbnail-slider ul .slick-slide[data-slick-index="' + currentSlide + '"]';
 	$('.thumbnail-slider ul .slick-slide.is-active').removeClass('is-active');
 	$(currrentNavSlideElem).addClass('is-active');
 });

 $('.thumbnail-slider ul').on('click', '.slick-slide', function(event) {
 	event.preventDefault();
 	var goToSingleSlide = $(this).data('slick-index');

 	$('.main-features-images ul').slick('slickGoTo', goToSingleSlide);
 });

});    
